export { Tabs, Item as Tab } from "./tabs";
